import { createSelector } from 'reselect';
import { getState } from './state';

export const getDenyUserListSlice = createSelector([getState], slice => {
  return slice.denyUserList;
});

export const getDenyUserList = createSelector(getDenyUserListSlice, state => {
  return state ?? {};
});
